import imgHomeLogo from './../contents/img/home-logo.svg';
import imgLoginLogo from './../contents/img/login-logo.svg';

const raw = process.env.REACT_APP_WEBSITE_NAME || '';
const siteName = raw.trim().replace(/^['"]|['"]$/g, ''); // remove aspas no começo/fim

const corPrincipal = siteName === 'neoshml' ? 'rgb(107, 19, 19)' : '#F24105';

export const LayoutParams = {
   colors: {
      corDoTemaPrincipal: corPrincipal,
      corSecundaria: '#FFF',
      corDoTextoPadrao: '#535b64',
      fundoCinza: 'rgb(222, 226, 230)',
      tableItemhHighlightBackgroundColor: 'rgb(222, 226, 230)',
   },
   imgHomeLogo: imgHomeLogo,
   imgLoginLogo: imgLoginLogo,
};
